import { render, staticRenderFns } from "./AdjustmentsComponent.vue?vue&type=template&id=5f508f26"
import script from "./AdjustmentsComponent.vue?vue&type=script&lang=js"
export * from "./AdjustmentsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports